import { TPreferencesLayer } from '@/shared/features/filter-preferences/context/filter-preferences-config-context.types';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import {
  useReadUserUiPreferencesQuery,
  useUpdateUserUiPreferencesMutation,
} from '@/shared/redux/api/ident/ident-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';
import { TUserUiPreferences } from '@/shared/types/ui-preferences.types';

// Needs no AppConfigProvider, so Modern can write the user blob without the filter-preferences config.
export const useUserUiPreferencesLayer =
  (): TPreferencesLayer<TUserUiPreferences> => {
    const isAuthenticated = !!useAppSelector(selectUser);
    const { refetch } = useReadUserUiPreferencesQuery(undefined, {
      skip: !isAuthenticated,
    });
    const [updateUserUiPreferences] = useUpdateUserUiPreferencesMutation();

    return {
      readFresh: async () => {
        const data = await refetch().unwrap();

        return {
          blob: (data?.readUserUiPreferences?.uiPreferences ??
            {}) as TUserUiPreferences,
          version: data?.readUserUiPreferences?.objectVersion ?? null,
        };
      },
      submit: async ({ blob, version }) => {
        await updateUserUiPreferences({
          uiPreferences: blob,
          objectVersion: (version ?? 0) + 1,
        }).unwrap();
      },
    };
  };
